var _rect, _rect2, _rect3, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRafRegistrationInvoice(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 174,
    viewBox: "0 0 240 174",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 240,
    height: 174,
    fill: "#E8E8E8"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -491.5,
    y: -8928.5,
    width: 977,
    height: 12373,
    rx: 4.5,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: -491.5,
    y: -8928.5,
    width: 977,
    height: 12373,
    rx: 4.5,
    stroke: "#7B61FF",
    strokeDasharray: "10 5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M218.616 105.598C218.616 105.598 256.616 8.91883 156.587 7.56387C56.5589 6.20892 10.8222 21.0507 10.3703 70.2203C9.9184 119.39 45.9467 165.341 108.739 165.85C171.532 166.359 205.487 147.859 218.616 105.598Z",
    fill: "#C9D3DB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M38.3333 158.13V118.576H201.667V132.815L186.694 137.189L171.722 142.633L141.778 153.522L92.4753 137.189L38.3333 158.13Z",
    fill: "#29333D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1449 22.9121C40.9067 22.9121 38.2817 25.5371 38.2817 28.7753V151.147L92.4579 130.206L141.792 146.539L186.737 130.206L201.718 125.832L201.718 28.7753C201.718 25.5372 199.093 22.9121 195.855 22.9121H44.1449Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M186.737 130.206L201.718 125.832L201.718 28.7753C201.718 25.5372 199.093 22.9121 195.855 22.9121H44.1449C40.9067 22.9121 38.2817 25.5371 38.2817 28.7753V151.147L92.4579 130.206L141.792 146.539L186.737 130.206ZM141.758 144.212L186.052 128.115L199.52 124.183L199.52 28.7753C199.52 26.7515 197.879 25.1108 195.855 25.1108H44.1449C42.121 25.1108 40.4804 26.7515 40.4804 28.7753V147.939L92.4005 127.87L141.758 144.212Z",
    fill: "#C9D3DB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8004 46.3647H77.091V48.7845H52.8004V46.3647Z",
    fill: "#8599AD"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8004 51.7162H77.091V54.136H52.8004V51.7162Z",
    fill: "#8599AD"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8005 63.8148H148.288V66.2345H52.8005V63.8148Z",
    fill: "#8599AD"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8005 69.1662H148.288V71.586H52.8005V69.1662Z",
    fill: "#8599AD"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8005 74.5177H148.288V76.9374H52.8005V74.5177Z",
    fill: "#8599AD"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8005 79.8691H148.288V82.2889H52.8005V79.8691Z",
    fill: "#8599AD"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8005 85.2206H148.288V87.6403H52.8005V85.2206Z",
    fill: "#8599AD"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8005 90.572H148.288V92.9918H52.8005V90.572Z",
    fill: "#8599AD"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8005 95.9228H116.877V98.3425H52.8005V95.9228Z",
    fill: "#8599AD"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M162.946 46.3647H187.236V48.7845H162.946V46.3647Z",
    fill: "#8599AD"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M162.946 51.7162H183.048V54.136H162.946V51.7162Z",
    fill: "#8599AD"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M162.946 57.0677H187.236V59.4874H162.946V57.0677Z",
    fill: "#8599AD"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M162.946 62.4191H183.048V64.8389H162.946V62.4191Z",
    fill: "#8599AD"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M162.946 67.7706H183.048V70.1903H162.946V67.7706Z",
    fill: "#8599AD"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M162.945 73.1213H183.048V75.5411H162.945V73.1213Z",
    fill: "#8599AD"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M209.333 110.667H168V146H209.333V110.667Z",
    fill: "#29333D"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M213.87 106.254H171.035V141.547H213.87V106.254Z",
    fill: "#EE8B00"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M193.347 111.727C193.982 111.727 194.172 111.947 194.172 112.582V113.936C196.709 114.292 198.174 115.563 199.25 117.772C199.582 118.436 199.445 118.793 198.697 119.125L197.344 119.731C196.709 120.034 196.406 119.897 196.049 119.233C195.306 117.796 194.392 117.107 192.516 117.107C190.17 117.107 189.095 117.796 189.095 119.37C189.095 120.391 190.033 121.026 191.001 121.217C191.47 121.329 192.13 121.437 192.985 121.52C194.529 121.657 195.301 121.769 196.655 122.238C197.344 122.487 197.867 122.761 198.282 123.122C199.054 123.841 199.743 125.219 199.743 126.983C199.743 129.988 197.73 132.031 194.168 132.558V133.995C194.168 134.63 193.972 134.85 193.342 134.85H191.822C191.187 134.85 190.967 134.63 190.967 133.995V132.588C188.206 132.231 186.359 130.824 185.45 128.336C185.23 127.73 185.45 127.315 186.085 127.066L187.439 126.567C188.128 126.318 188.431 126.484 188.734 127.173C189.34 128.718 190.581 129.49 192.457 129.49C194.993 129.49 196.264 128.688 196.264 127.061C196.264 126.206 195.878 125.683 195.076 125.351C194.275 125.048 193.586 124.935 192.345 124.828C190.825 124.691 189.97 124.525 188.646 124.026C187.986 123.777 187.458 123.474 187.048 123.118C186.222 122.375 185.557 121.051 185.557 119.365C185.557 116.384 187.434 114.4 190.967 113.931V112.577C190.967 111.942 191.187 111.722 191.822 111.722H193.342L193.347 111.727Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRafRegistrationInvoice);
export default __webpack_public_path__ + "static/media/raf_registration_invoice.8e0e28855fe5ecc3aaf808df63db5e99.svg";
export { ForwardRef as ReactComponent };